import { render } from "./ListItems.vue?vue&type=template&id=24dde0e0&scoped=true"
import script from "./ListItems.vue?vue&type=script&lang=js"
export * from "./ListItems.vue?vue&type=script&lang=js"

import "./ListItems.vue?vue&type=style&index=0&id=24dde0e0&scoped=true&lang=css"

import exportComponent from "E:\\Data\\Repos\\Propnroll\\Propnroll\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24dde0e0"]])

export default __exports__